import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'isDate'
})
export class IsDatePipe implements PipeTransform {
  transform(date: Date, options?: { format: string }): string {
    const formattedDate = moment(date).format(options?.format);
    if (formattedDate !== 'Invalid date') {
      return formattedDate;
    }
  }
}
